import { translateFn } from '../../../../utils/translator.helper';
import { html, TemplateResult } from 'lit';
import { createRows } from '../../utils';
import { BaseSpecificDetailsView } from '../../specificDetailViewByType/baseSpecificDetailsView';
import { UNAVAILABLE_DATA } from '../../../types';

export class DiscoveredIpsBlock extends BaseSpecificDetailsView {
  static getGeneralInfo(data: any, dependencies: any): TemplateResult {
    const detailsInfo = [{ label: translateFn('CIDR'), value: data.cidr }];

    const rows = createRows(detailsInfo, UNAVAILABLE_DATA);

    return html`${rows}`;
  }
}
